import { t } from 'i18next';

export const confirm_answers = [
  { label: t('confirm-values.yes'), value: 'yes' },
  { label: t('confirm-values.no'), value: 'no' },
];
